import Icon from '../components/Icon.vue'

Icon.register({"play":{"width":1408,"height":1792,"paths":[{"d":"M1384 927l-1328 738q-23 13-39.5 3t-16.5-36v-1472q0-26 16.5-36t39.5 3l1328 738q23 13 23 31t-23 31z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/play.js
// module id = 1170
// module chunks = 0